import script from "./SizeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SizeEditor.vue?vue&type=script&setup=true&lang=js"

import "./SizeEditor.vue?vue&type=style&index=0&id=fa1948d2&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa1948d2"]])

export default __exports__